module.exports = __webpack_public_path__ + "img/partner_contact_success.2b40ba58.svg";